import {
  Card,
  Grid,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  InputAdornment,
  FormControl,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody
} from '@mui/material';
import { withStyles } from '@mui/styles';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import moment, { Moment } from 'moment';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SearchIcon from '@mui/icons-material/Search';
import { ApplyLeave } from 'src/models/leave';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectsInternal } from 'src/services/projectDetailService';
import { getProjectManagerDetailsByProject } from 'src/services/projectService';
import { AppActions } from 'src/store/AppReducer';
import {
  getAllEmployeeNameList,
  getReporterByEmpId
} from 'src/services/employeeService';
import { ReporterDetails } from './Leave';
import { RootStateType } from 'src/store/RootReducer';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import {
  applyLieuLeave,
  getLieuLeaveDayCount
} from 'src/services/leaveService';
import TotalLeaves from './TotalLeaves';
import { useNavigate, useParams } from 'react-router';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { DatePicker, PickersDay } from '@mui/lab';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';

export interface LeaveInformation {
  name: string;
  designation: string;
  email: string;
  contact: string;
  segment: string;
  customer: string;
  HrApproval: string;
}

const LieuLeave: React.FC = () => {
  const { id } = useParams();
  const myRef = useRef<DateRangePicker>();
  const [dateType, setDateType] = useState('full');
  const [tempDateType, setTempDateType] = useState('full');
  const [projectList, setProjectList] = useState([]);
  const [projectLeadList, setProjectLeadList] = useState([]);
  let initialData: ReporterDetails[] = [];
  const [reporter, setReporter] = useState<any>(initialData);
  const [state, setState] = React.useState({
    startDate: '',
    endDate: '',
    focusedInput: ''
  });
  const { register, handleSubmit, reset, setValue, getValues } =
    useForm<ApplyLeave>();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateChanged, setDateChanged] = useState(false);
  const [dayCount, setDayCount] = useState(0);
  const [project, setProject] = useState('');
  const [projectLead, setProjectLead] = useState('');

  const [daysCountError, setDaysCountError] = useState('');
  const [leaveReasonError, setLeaveReasonError] = useState('');
  const [fromDateError, setFromDateError] = useState('');
  const [toDateError, setToDateError] = useState('');
  const [projectLeadError, setProjectLeadError] = useState('');
  const [projectError, setProjectError] = useState('');
  const [reportingManagerError, setReportingManagerError] = useState('');
  const [leaveReasonLength, setLeaveReasonLength] = useState(0);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [isDisabledRMPendingBtn, setIsDisabledRMPendingBtn] =
    useState<boolean>(false);
  const [breadcrumbs, setBreadcrumbs] = useState<boolean>(false);
  const [isLeaveSummary, setIsLeaveSummary] = useState<boolean>(false);
  const [isDisabledEmployeeLeavesBtn, setIsDisabledEmployeeLeavesBtn] = useState<boolean>(false);
  const [singleDate, setSingleDate] = useState<Date | null>(null);
  const [highlightedDays, setHighlightedDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState([]);
  const [highlightedMonth, setHighlightedMonth] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState([]);
  const [mainProjectManager, setMainProjectManager] = useState<any>();
  const [selectLieuStartDate, setSelectLieuStartDate] = useState('');
  const [selectLieuEndDate, setSelectLieuEndDate] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentDate = new Date();

  const maxDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const minDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate() - 7
  );

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const [openConfirmation, setOpenConfirmation] = useState(false);

  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const employeeId = useSelector(
    (state: RootStateType) => state.appReducer.user.EmployeeId
  );
  const isReportingManager = useSelector(
    (state: RootStateType) => state.leaveManagementReducer.isReportingManager
  );

  useEffect(() => {
    const user = window.localStorage.getItem('user');
    const userModel = JSON.parse(user);
    const selectedUserRole = userModel?.Roles;

    const user_role = selectedUserRole.split(',')
    if (
      user_role.includes('Super User') ||
      user_role.includes('HR Manager') ||
      user_role.includes('Assistant HR Manager') ||
      user_role.includes('HR Executive')
    ) {
      setIsDisabledRMPendingBtn(true);
      setBreadcrumbs(false);
      setIsDisabledEmployeeLeavesBtn(true);
    } else if (isReportingManager) {
      setIsDisabledRMPendingBtn(false);
      setBreadcrumbs(false);
      setIsDisabledEmployeeLeavesBtn(true);
    } else {
      setIsDisabledRMPendingBtn(false);
      setBreadcrumbs(true);
      setIsDisabledEmployeeLeavesBtn(false);
    }
  }, []);

  const handleDateTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onReset();
    setDateType((event.target as HTMLInputElement).value);
    if (dateType !== 'half') {
      setValue('dateType', false);
      setTempDateType('half');
      setHighlightedDays([minDate.getDate()]);
      setHighlightedMonth([minDate.getMonth()]);
    } else {
      setValue('dateType', true);
      setTempDateType('full');
    }
    setValue('daysCount', 0);
    setMainProjectManager(null);
    setSelectLieuStartDate('');
    setSelectLieuEndDate('');
  };

  const handleReset = () => {
    if (dateType === 'full') {
      myRef.current.setStartDate(moment());
      myRef.current.setEndDate(moment());
    }
    setStartDate('');
    setEndDate('');
    setDayCount(0);
    setValue('fromDate', '');
    setValue('toDate', '');
    setDateChanged(false);
  };

  const onReset = () => {
    setDateChanged(false);
    setDateType('full');
    setTempDateType('full');
    setDayCount(0);
    setProject('');
    setProjectLead('');
    handleReset();
    setLeaveReasonLength(0);
    setDaysCountError('');
    setLeaveReasonError('');
    setFromDateError('');
    setToDateError('');
    setProjectLeadError('');
    setProjectError('');
    setSingleDate(null);
    setSelectedDay([]);
    setHighlightedDays([]);
    setHighlightedMonth([]);
    setSelectedMonth([]);

    reset();
  };

  const TextFieldStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const dateStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginTop: 5,
    fontSize: '13px'
  };

  const errorStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '11px',
    color: 'red'
  };

  const getProjectList = () => {
    dispatch(AppActions.showLoader());
    getProjectsInternal()
      .then((res) => {
        setProjectList(res.data.reverse());
        dispatch(AppActions.hideLoader());
      })
      .catch(() => {
        dispatch(AppActions.hideLoader());
      });
  };

  const getAllEmployeeList = () => {
    dispatch(AppActions.showLoader());
    getAllEmployeeNameList()
      .then((res) => {
        setProjectLeadList(res.data);
        dispatch(AppActions.hideLoader());
      })
      .catch(() => {
        dispatch(AppActions.hideLoader());
      });
  };

  const getReporter = (empId) => {
    dispatch(AppActions.showLoader());
    getReporterByEmpId(empId).then((res) => {
      res.data.map((item, index) => {
        if (index === 0) {
          setReporter(item);
          setValue('reportingManagerId', item.employeeId);
        }
      });
      dispatch(AppActions.hideLoader());
    });
  };

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState('');

  const projectNames = useMemo(
    () =>
      projectList?.length > 0 &&
      projectList?.filter((option) => containsText(option.name, searchText)),
    [searchText, projectList]
  );

  const projectLeadNames = useMemo(
    () =>
      projectLeadList?.length > 0 &&
      projectLeadList?.filter((option) =>
        containsText(option.name, searchText) && !option?.isResign
      ),
    [searchText, projectLeadList]
  );

  const getInitSettings = () => {
    let settings = {
      minDate:new Date(currentDate.getFullYear(), 0, 1),
      maxDate:new Date()
    };
    return settings;
  };

  useEffect(() => {
    if (startDate && endDate) {
      myRef.current.setStartDate(moment());
      myRef.current.setEndDate(moment());
    }
    setValue('fromDate', startDate);
    setValue('toDate', endDate);
    setValue('dateType', true);
    getProjectList();
    getAllEmployeeList();
    getReporter(employeeId);
  }, []);

  const arrangeDate = (start: Date, end: Date) => {
    setDateChanged(true);
    var sDate = moment(start);
    var eDate = moment(end);
    setStartDate(sDate.format('DD/MM/YYYY'));
    setEndDate(eDate.format('DD/MM/YYYY'));
  };

  const getDaysCount = (start, end) => {
    dispatch(AppActions.showLoader());
    getLieuLeaveDayCount(start, end)
      .then((res) => {
        setDayCount(res.data.data);
        setValue('daysCount', res.data.data);
        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(e.response?.data?.message);
        setSnackbarSeverity('Warning');
        setSnackBarOpen(true);
        setStartDate('');
        setEndDate('');
        setValue('fromDate', '');
        setValue('toDate', '');
        setDateChanged(false);
        setSingleDate(null);
        setSelectedDay([]);
        setSelectedMonth([]);
        setHighlightedDays([minDate.getDate()]);
        setHighlightedMonth([minDate.getMonth()]);
      });
  };

  const validateiSFullDay = (data: ApplyLeave) => {
    if (data.dateType) {
      return data.fromDate !== '' && data.toDate !== '' ? true : false;
    } else {
      return data.toDate === '' || data.toDate === 'Invalid date'
        ? false
        : true;
    }
  };

  const validateDayCount = (data: ApplyLeave) => {
    if (data.dateType || tempDateType === 'full') {
      if (data.daysCount === 0 || data.daysCount === undefined) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const onSubmit = () => {
    dispatch(AppActions.showLoader());
    applyLieuLeave(getValues())
      .then((res) => {
        if (res.data.statusCode === 200) {
          dispatch(AppActions.hideLoader());
          setSnackBarMessage(
            `Your Lieu Leave Eligibility request has been sent to the ${mainProjectManager?.employeeId ? 'project' : 'reporting'} manager successfully.`
          );
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          setOpenConfirmation(false);
          onReset();
          setIsLeaveSummary(true);
        }
      })
      .catch((err) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          err.response?.data?.message
            ? err.response.data.message
            : 'Unable to request leave/s'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      });
  };

  const validateRequiredField = () => {
    let data = getValues();

    setDaysCountError('');
    setLeaveReasonError('');
    setFromDateError('');
    setToDateError('');
    setReportingManagerError('');
    setProjectError('');
    setProjectLeadError('');

    setValue('employeeId', employeeId);
    setValue('reportingManagerId', mainProjectManager?.employeeId ? mainProjectManager.employeeId : reporter?.employeeId);
    setValue('defaultReportingManagerId', reporter?.employeeId);
    if (dateType === 'full') {
      setValue('dateType', true);
      data.dateType = true;
    } else {
      setValue('dateType', false);
      data.dateType = false;
    }

    if (data.fromDate === '' && data.toDate === '') {
      setValue('fromDate', startDate);
      setValue('toDate', endDate);
      data.fromDate = startDate;
      data.toDate = endDate;
    }
    if (data.fromDate === undefined) {
      data.fromDate = '';
    }

    if (data.toDate === undefined) {
      data.toDate = '';
    }
    if (
      data.leaveTypeId !== 0 &&
      validateiSFullDay(data) &&
      validateDayCount(data) &&
      data.additionalDetails?.length < 501 &&
      data.reportingManagerId !== '' &&
      data.projectId !== '' &&
      data.projectLeadId !== ''
    ) {
      setOpenConfirmation(!openConfirmation);
    } else {
      if (
        (data.dateType || dateType === 'full') &&
        data.fromDate === '' &&
        (data.toDate === '' || data.toDate === 'Invalid date')
      ) {
        setToDateError('Date range is required');
      }
      if (
        !data.dateType &&
        (data.toDate === '' || data.toDate === 'Invalid date')
      ) {
        setToDateError('Date is required');
      }
      if (data.additionalDetails?.length > 500) {
        setLeaveReasonError('Max character length: 500');
      }
      if (data.reportingManagerId === '') {
        setReportingManagerError('Reporting manager is required');
      }
      if (data.projectId === '') {
        setProjectError('Project is required');
      }
      if (data.projectLeadId === '') {
        setProjectLeadError('Project Lead is required');
      }
    }
  };

  const projectManagerLoadingHandler = (projectId: string) => {
    dispatch(AppActions.showLoader());
    let project = {
      projectId: projectId,
      startDate: selectLieuStartDate,
      endDate: selectLieuEndDate
    }

    getProjectManagerDetailsByProject(project).then((res: any) => {
      if (res.status === 200) {
        if (res.data?.employeeId !== employeeId) {
          setMainProjectManager(res.data);
        }else {
          setMainProjectManager('');
        }
      }else{
        setMainProjectManager('');
      }
      dispatch(AppActions.hideLoader());
    }, (err) => {
      setMainProjectManager('');
      dispatch(AppActions.hideLoader());
    });
  }

  return (
    <Grid sx={{ mx: 3 }}>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            {!breadcrumbs && (
              <span
                style={{
                  cursor: 'pointer',
                  marginRight: '3px'
                }}
                onClick={() => {
                  navigate('/leave-management');
                }}
              >
                Leave Management
              </span>
            )}
            {!breadcrumbs && (
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: '550',
                  color: '#223354'
                }}
              >
                / Lieu Leave Application
              </span>
            )}
            {breadcrumbs && (
              <span
                style={{
                  marginRight: '3px'
                }}
              >
                Lieu Leave Application
              </span>
            )}
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
        <Grid item>
          <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/apply-leave`);
            }}
          >
            Apply Leave
          </Button>
          {/* <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/apply-wfh`);
            }}
          >
            Apply Work From Home
          </Button> */}
          {isDisabledRMPendingBtn && (
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/RM-pending-requests`);
              }}
            >
              PM/RM Pending Requests
            </Button>
          )}
          {isDisabledEmployeeLeavesBtn && (
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/employee-leaves`);
              }}
            >
              Employee Leaves
            </Button>
          )}
          <Button
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/my-leave-history/id`);
            }}
          >
            My Leave History
          </Button>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 1, mb: 1, px: 0, mx: 0, pl: 0 }}>
        <Grid xs={8}>
          <Card style={{ padding: '1rem' }}>
            <Grid item style={{ paddingBottom: '1rem' }}>
              <Typography
                style={{ fontSize: '12px', paddingLeft: '15px' }}
                variant="h3"
              >
                Lieu Leave Application
              </Typography>
            </Grid>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2} sx={{ paddingBottom: '1rem' }}>
                <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Day Type<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    className="radioBtn"
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{ paddingLeft: '15px' }}
                    value={dateType}
                    onChange={handleDateTypeChange}
                  >
                    <FormControlLabel
                      value="full"
                      control={<Radio />}
                      label="Full Day"
                    />
                    <FormControlLabel
                      value="half"
                      control={<Radio />}
                      label="Half Day"
                    />
                  </RadioGroup>
                  <Typography style={errorStyle}></Typography>
                </Grid>
                {dateType === 'full' ? (
                  <Fragment>
                    <Grid className="date-range" item xs={6}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Extra Worked Days<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <DateRangePicker
                        ref={myRef}
                        initialSettings={getInitSettings()}
                        onCallback={(start, end) => arrangeDate(start, end)}
                        onApply={(event, picker) => {
                          setValue('fromDate', startDate);
                          setValue('toDate', endDate);
                          setToDateError('');
                          setDaysCountError('');
                          getDaysCount(
                            moment(picker.startDate).format('DD/MM/YYYY'),
                            moment(picker.endDate).format('DD/MM/YYYY')
                          );
                          setSelectLieuStartDate(moment(picker.startDate).format('YYYY-MM-DD'));
                          setSelectLieuEndDate(moment(picker.endDate).format('YYYY-MM-DD'));
                          setProject('');
                          setMainProjectManager('');
                        }}
                        onCancel={() => {
                          handleReset();
                        }}
                      >
                        <Grid style={dateStyle}>
                          <div style={{ position: 'relative' }}>
                            <TextField
                              placeholder="DD/MM/YYYY - DD/MM/YYYY"
                              value={
                                dateChanged
                                  ? (startDate && startDate) +
                                    ' - ' +
                                    (endDate && endDate)
                                  : ''
                              }
                              id="date"
                              fullWidth
                              size="small"
                            />
                            <CalendarTodayIcon
                              className="calendar-icon"
                              fontSize={'small'}
                            />
                          </div>
                        </Grid>
                      </DateRangePicker>
                      <Typography style={errorStyle}>{toDateError}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Days Count<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Days Count"
                        variant="outlined"
                        disabled
                        value={dayCount}
                        {...register('daysCount')}
                        onChange={() => {
                          setDaysCountError('');
                        }}
                      />
                    </Grid>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Grid item xs={6}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Extra Worked Day<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <div style={{ marginLeft: 15, marginRight: 15 }}>
                        <FormControl fullWidth>
                          <DatePicker
                            InputProps={{
                              className: 'date-picker'
                            }}
                            minDate={new Date(currentDate.getFullYear(), 0, 1)}
                            maxDate={new Date()}
                            renderInput={(params) => (
                              <TextField {...params} id="date" />
                            )}
                            renderDay={(day, _value, DayComponentProps) => {
                              const isDefaultDate = 
                              !DayComponentProps.outsideCurrentMonth && 
                              highlightedDays.indexOf(day.getDate()) >= 0 &&
                              highlightedMonth.indexOf(day.getMonth()) >= 0;

                              const isSelectDate = 
                              !DayComponentProps.outsideCurrentMonth && 
                              selectedDay.indexOf(day.getDate()) >= 0 &&
                              selectedMonth.indexOf(day.getMonth()) >= 0;
                                
                              return (
                                <PickersDay {...DayComponentProps} style={{
                                  backgroundColor: isSelectDate ? 'blue' : isDefaultDate ? 'rgba(34, 51, 84, 0.1)': 'white',
                                  color: isSelectDate ? 'white' : isDefaultDate ? 'black': undefined,
                                  border: isDefaultDate ? '1px solid rgba(34, 51, 84, 0.7)' : '0px solid white'
                                }} />
                              )
                            }}
                            value={singleDate}
                            onChange={(newValue) => {
                              if (newValue) {
                                setValue('fromDate', moment(newValue).format('DD/MM/YYYY'));
                                setValue('toDate', moment(newValue).format('DD/MM/YYYY'));
                                setToDateError('');
                                getDaysCount(
                                  moment(newValue).format('DD/MM/YYYY'),
                                  moment(newValue).format('DD/MM/YYYY')
                                  );
                                setSingleDate(newValue);
                                setSelectedDay([newValue.getDate()]);
                                setSelectedMonth([newValue.getMonth()]);
                                setHighlightedDays([]);
                                setHighlightedMonth([]);
                                setSelectLieuStartDate(moment(newValue).format('YYYY-MM-DD'));
                                setSelectLieuEndDate(moment(newValue).format('YYYY-MM-DD'));
                                setProject('');
                                setMainProjectManager('');
                              }
                            }}
                          />
                        </FormControl>
                      </div>
                      <Typography style={errorStyle}>{toDateError}</Typography>
                    </Grid>
                  </Fragment>
                )}
                <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Project Worked On<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <Grid sx={{ paddingLeft: '15px' }}>
                    <Select
                      disabled={((startDate && endDate) || singleDate) ? false : true}
                      className="select-text"
                      size="small"
                      style={selectStyle}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      value={project || ''}
                      onClose={() => setSearchText('')}
                      {...register('projectId')}
                      onChange={(e) => {
                        setProject(e.target.value);
                        setProjectError('');
                        projectManagerLoadingHandler(e.target.value);
                      }}
                    >
                      <MenuItem
                        style={{ display: 'none' }}
                        selected
                        disabled
                        value={''}
                      >
                        Select Project Worked On
                      </MenuItem>
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Type to search..."
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => setSearchText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                              // Prevents autoselecting item while typing (default Select behaviour)
                              e.stopPropagation();
                            }
                          }}
                        />
                      </ListSubheader>
                      {projectNames?.length > 0 &&
                        projectNames.map((element) => (
                          <MenuItem key={element.id} value={element.id}>
                            {element.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </Grid>
                  <Typography style={errorStyle}>{projectError}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Project Lead<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <Grid sx={{ paddingLeft: '15px' }}>
                    <Select
                      className="select-text"
                      size="small"
                      style={selectStyle}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      value={projectLead || ''}
                      onClose={() => setSearchText('')}
                      {...register('projectLeadId')}
                      onChange={(e) => {
                        setProjectLead(e.target.value);
                        setProjectLeadError('');
                      }}
                    >
                      <MenuItem
                        style={{ display: 'none' }}
                        selected
                        disabled
                        value={''}
                      >
                        Select Project Lead
                      </MenuItem>
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Type to search..."
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => setSearchText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                              // Prevents autoselecting item while typing (default Select behaviour)
                              e.stopPropagation();
                            }
                          }}
                        />
                      </ListSubheader>
                      {projectLeadNames?.length > 0 &&
                        projectLeadNames.map((element) => (
                          <MenuItem
                            key={element.employeeId}
                            value={element.employeeId}
                          >
                            {element.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </Grid>
                  <Typography style={errorStyle}>{projectLeadError}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Reporting Manager<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <TextField
                    inputProps={{ maxLength: 30 }}
                    size="small"
                    style={TextFieldStyle}
                    fullWidth
                    placeholder="Enter Reporting Manager"
                    variant="outlined"
                    disabled
                    value={reporter.name}
                    key={reporter.employeeId}
                  />
                  <Typography style={errorStyle}>
                    {reportingManagerError}
                  </Typography>
                </Grid>
                {mainProjectManager?.employeeId && (
                  <Grid item xs={6}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Project Manager
                  </Typography>
                  <TextField
                    inputProps={{ maxLength: 30 }}
                    size="small"
                    style={TextFieldStyle}
                    fullWidth
                    placeholder="Enter Project Manager"
                    variant="outlined"
                    disabled
                    value={mainProjectManager.name}
                    key={mainProjectManager.employeeId}
                  />
                </Grid>
                )}
                <Grid item xs={12}>
                  <Typography
                    style={LabelStyle}
                    fontWeight="light"
                    variant="h5"
                  >
                    Additional Details (Optional)
                  </Typography>
                  <TextField
                    size="small"
                    multiline
                    rows={3}
                    className="input-text"
                    style={TextFieldStyle}
                    inputProps={{
                      style: {
                        fontSize: '13px'
                      },
                      maxLength: 500
                    }}
                    fullWidth
                    placeholder="Enter Additional Details"
                    variant="outlined"
                    {...register('additionalDetails')}
                    onChange={(e) => {
                      setLeaveReasonLength(e.target.value.length);
                    }}
                  />
                  <Typography
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginRight: '1rem',
                      fontSize: '12px'
                    }}
                  >
                    {leaveReasonLength} / 500
                  </Typography>
                  <Typography style={errorStyle}></Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    sx={{
                      paddingLeft: '15px',
                      paddingRight: '15px',
                      display: 'flex',
                      paddingTop: '1rem'
                    }}
                  >
                    <span style={{ color: 'red' }}>*</span>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      To all staff who work a minimum of nine (09) hours on a
                      Sunday, Saturday or mercantile holiday, subject to the
                      prior approval by the Supervisor.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    sx={{
                      paddingLeft: '15px',
                      paddingRight: '15px',
                      display: 'flex'
                    }}
                  >
                    <span style={{ color: 'red' }}>*</span>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      Half a day of lieu leave is granted after four (04) hours
                      (but less than nine(09) hours) of work on a Sunday,
                      Saturday, or mercantile holiday.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    sx={{
                      paddingLeft: '15px',
                      paddingRight: '15px',
                      display: 'flex'
                    }}
                  >
                    <span style={{ color: 'red' }}>*</span>
                    <Typography
                      style={LabelStyle}
                      fontWeight="light"
                      variant="h5"
                    >
                      Interns / Trainees are not entitled to lieu leave.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Divider
                style={{ marginTop: '1rem', marginBottom: '1rem' }}
              ></Divider>
              <Grid
                item
                sx={{
                  mt: 2,
                  pr: 2,
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
                xs={12}
              >
                <Button
                  sx={{
                    width: '10%',
                    fontWeight: 'normal',
                    background: '#F5F7FF',
                    fontSize: '13px'
                  }}
                  onClick={onReset}
                >
                  Reset
                </Button>
                <Button
                  sx={{
                    ml: 2,
                    width: '10%',
                    fontSize: '13px',
                    fontWeight: 'normal',
                    background: '#0069E4'
                  }}
                  variant="contained"
                  type="button"
                  onClick={() => validateRequiredField()}
                >
                  Apply
                </Button>
              </Grid>
              <ConfirmationModal
                isLoading={isLoading}
                open={openConfirmation}
                toggle={validateRequiredField}
                message={`Are you sure you want to apply for Lieu Leave Eligibility?`}
                onConfirm={() => onSubmit()}
                noToggle={validateRequiredField}
              />
            </form>
          </Card>
          <SnackBar
            snackBarOpen={snackBarOpen}
            setSnackBarOpen={setSnackBarOpen}
            snackBarMessage={snackBarMessage}
            snackbarSeverity={snackbarSeverity}
          />
        </Grid>
        <Grid xs={4} style={{ paddingLeft: '1rem' }}>
          <TotalLeaves sendData={isLeaveSummary} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LieuLeave;
